import { Injectable } from "@angular/core";
import { toast } from "ngx-sonner";
import type { ToastrOptions } from "./toastr.interface";

@Injectable({
  providedIn: "root",
})
export class ToastrService {
  success(message: string, _title?: string, options?: ToastrOptions): void {
    toast.success(
      message,
      options?.timeOut != null ? { duration: options.timeOut } : undefined,
    );
  }

  error(message: string, _title?: string, options?: ToastrOptions): void {
    toast.error(
      message,
      options?.timeOut != null ? { duration: options.timeOut } : undefined,
    );
  }

  warning(message: string, _title?: string, options?: ToastrOptions): void {
    toast.warning(
      message,
      options?.timeOut != null ? { duration: options.timeOut } : undefined,
    );
  }

  info(message: string, _title?: string, options?: ToastrOptions): void {
    toast.info(
      message,
      options?.timeOut != null ? { duration: options.timeOut } : undefined,
    );
  }
}
